module.exports = __webpack_public_path__ + "static/img/Arc-log-whatsapp.36d73928.png";